:host {
  --label-color: #{$colorPrimary70};
  --background-color: #{$colorLemonyellow50};
  --border-color: #{$colorPrimary70};
  --border-width: 8px;
}

.stzh-disturber {
  position: relative;
  display: flex;
  background-color: var(--background-color);
  transition: background-color $baseTransitionAnimationSpeed;
  z-index: var(--stzh-z-index-masked);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    border-style: solid;
    border-width: 0px;
    border-color: var(--border-color);
    border-bottom-width: var(--border-width);

    @include mq($from: medium) {
      border-right-width: var(--border-width);
    }
  }

  &__content {
    @include spaceCurve("padding-bottom", "medium");
    padding-top: space("xxlarge");
    padding-left: space("large");
    padding-right: space("large");
    flex-grow: 1;
  }

  &__label {
    @include font("title");
    @include fontCurve("h4", "heading");
    color: var(--label-color);
    transition: color $baseTransitionAnimationSpeed;
    margin-bottom: space("medium");
  }

  &__close-wrapper {
    position: absolute;
    top: 0px;
    right: 0px;

    @include mq($from: medium) {
      right: var(--border-width);
    }
  }
}
